define(function (require) {

    var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");
    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var TableActionsViewController = ViewController.extend({
        ControllerName: "TableActionsViewController",

        LPViewMap: {
            actionsContainer: ".lpview_table_actions_container"
        },

        LPClassesMap: {
        },

        initialize: function (constructorData) {
            this.tableName = constructorData.tableName;
            this.tableItemsStateModelPath = constructorData.tableItemsStateModelPath;
            this.context = constructorData.context || this;
            this.actionsContainer = this.getFirstElement();
            this.dropDownActionCollection =  new DropdownMenu.Collection( constructorData.actionDropdownArray);
            this.tableStateChangedConfiguration =   constructorData.tableStateChangedConfiguration;
            this.initializeView();
        },

        events: function () {
            this.bindModel({modelPath: this.tableItemsStateModelPath, callback: this.handleTableStateChanged});
        },

        render: function () {
            this.actionDropDown.render();
        }
    });

    TableActionsViewController.prototype.initializeView = function () {
        this.actionDropDown = new DropdownMenu({
            el: this.actionsContainer,
            name: agentLEManager.translateLE("LEFramework.global.captions.action"),
            collection: this.dropDownActionCollection,
            align: DropdownMenu.ALIGN.RIGHT,
            permutation: DropdownMenu.PERMUTATION.D
        });
        this.actionDropDown.on(DropdownMenu.TRIGGERING.CHANGE,this._onActionSelected,this);

    };
    TableActionsViewController.prototype._onActionSelected = function(actionId) {
        var actionModel = this.dropDownActionCollection.get(actionId);
        actionModel.get("callbackFunc")();
    };


    TableActionsViewController.prototype.handleTableStateChanged = function (data) {
        if (data && data.newValue) {
            switch (data.newValue.status) {
                case "fetching":
                    this.actionDropDown.setEnabled(false);
                    break;
                case "fetched":
                    this.actionDropDown.setEnabled(true);
                    break;
                default:
                    this.actionDropDown.setEnabled(true);
            }
        }
    };


    TableActionsViewController.prototype.setActionAvailability =  function(actionId,enabled,tooltipKey) {
        var tooltip = tooltipKey?this.translate(tooltipKey): "";
        var action =  this.dropDownActionCollection.get(actionId);
        if (action) {
            action.set({"enabled": enabled, "title": tooltip});
        }
    };

    window.TableActionsViewController = TableActionsViewController;

    return TableActionsViewController;

});
